import type { RolesContextType } from './types'
import { createContext } from 'react'

export const RolesContext = createContext<RolesContextType | undefined>(undefined)
